import React, { CSSProperties, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import BigPicMain, { BigPicHeader } from './BigPicMain';
import './SimpleBigPic.scss';
import intl from 'react-intl-universal';
import {
  debounce,
  formatSize,
  getWatermarks,
  isWeb,
  getPageSameType
} from '../../utils/util';
import imageUtil, { downloadImage } from '../../utils/image';
import stat from '../../utils/stat';
import ReactSVG from 'react-svg';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';
import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll
} from 'body-scroll-lock';

interface ISimpleBigPic {
  pageType: string;
  index: number;
  list: any[];
  setIndex: (index: number) => void;
  style?: CSSProperties;
  loadBigPic?: () => void;
  toNext?: () => void;
  disablePinchZoom?: boolean;
  loadFinish?: (index: number, size?: number) => void;
  rootStore?: RootStore;
  onClose: () => void;
}

let containerEl = {} as any;
const SimpleBigPic = function(props: ISimpleBigPic) {
  let { pageType } = props;

  if (!containerEl[pageType]) {
    containerEl[pageType] = document.createElement('div');
  }

  useEffect(() => {
    if (!containerEl[pageType].parentNode)
      document.body.appendChild(containerEl[pageType]);
    return () => {
      if (containerEl[pageType].parentNode)
        document.body.removeChild(containerEl[pageType]);
    };
  }, [props.pageType]);
  const { index, list, setIndex } = props;
  // todo: 不知道为什么切换的时候会报警，虽然目前没有发现什么实质的问题
  // 先放这里了，等后面有空看看是什么导致的问题
  // 奇怪，这里的警告已经不见了

  const nextClick = () => {
    if (index + 1 >= list.length) {
      props.rootStore!.uiStore.showToast({
        content: intl.get('This is the last one photo'),
        time: 1000
      });
      return;
    }
    setIndex(index + 1);
  };

  const { galleryStore } = props.rootStore!;
  const [downloading, setDownloading] = useState(false);
  const downloadToast = (path: string, name: string) => {
    if (!downloading) {
      setDownloading(true);
      props.rootStore!.uiStore.showToast({
        content: intl.get('Downloading'),
        time: 0
      });
      downloadImage(path, name).then(() => {
        props.rootStore!.uiStore.hideToast();
        setDownloading(false);
      });
    }
  };

  const longPress = () => {
    const image = list[index];
    stat.event('image_download', image.id);
  };

  const keyup = (e: { keyCode: number }) => {
    let targetIndex = index;
    if (e.keyCode == 37) {
      targetIndex = Math.max(0, targetIndex - 1);
    }
    if (e.keyCode == 39) {
      if (targetIndex === list.length - 1) {
        props.rootStore!.uiStore.showToast({
          content: intl.get('This is the last one photo'),
          time: 1000
        });
      }
      targetIndex = Math.min(list.length - 1, targetIndex + 1);
    }
    var target = list[targetIndex];
    if (target && target.id) {
      // props.showBigPic({
      //   index: targetIndex,
      //   id: target.id
      // });
      props.setIndex(targetIndex);
    }
  };

  // 开启时注册keyup事件，销毁时取消掉
  useEffect(() => {
    index !== -1 && isWeb() && window.addEventListener('keyup', keyup);

    if (index !== -1) {
      disableBodyScroll(window.document.body);
    }
    return () => {
      isWeb() && window.removeEventListener('keyup', keyup);

      if (index !== -1) {
        clearAllBodyScrollLocks();
      }
    };
  }, [index]);

  const { wxuserStore } = props.rootStore!;

  return createPortal(
    index !== -1 ? (
      <div
        className="simple-big-pic"
        onClick={() => setIndex(-1)}
        style={props.style}
      >
        <BigPicMain
          currentImageIndex={index}
          list={list}
          setCurrentImageIndex={setIndex}
          onLongPress={longPress}
          hideBigPic={() => {
            setIndex(-1);
            props.onClose();
          }}
          loadFinish={props.loadFinish}
          disablePinchZoom={true}
        />
        <div className="bigpic-wrapper" onClick={e => e.stopPropagation()}>
          <BigPicHeader
            detail={list[index]}
            currentImageIndex={index}
            count={list.length}
            tips="建议横屏观看"
          ></BigPicHeader>
          <div className="bigpic-operation">
            <img
              src={require('../../assets/x-circle.png')}
              alt=""
              className="bigpic-close position-document-big-pic"
              onClick={() => {
                setIndex(-1);
                props.onClose();
              }}
            />
          </div>
          {/*}<img
            src={require('../../assets/x-circle.png')}
            alt=""
            className="bigpic-close"
            onClick={() => setIndex(-1)}
          />*/}
          {/*随意写一个高度试试，IOS上显示有问题，不明为什么*/}
          <div style={{ flex: 1, zIndex: -1, height: 100 }} />
        </div>
      </div>
    ) : null,
    containerEl[pageType]
  );
};

export default inject('rootStore')(observer(SimpleBigPic));
